"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardInput = void 0;
const React = require("react");
const react_1 = require("react");
const CreditCardSummary_1 = require("../../payments/CreditCardSummary");
/**
 * Provides a text input.
 */
const CreditCardInput = ({ value, onInputChange, disclaimer }) => {
    // wait for the card to be set
    const onChange = (0, react_1.useCallback)(async (card) => {
        onInputChange && onInputChange(card);
    }, [onInputChange]);
    return (React.createElement("div", { "data-test-card": JSON.stringify(value), "data-test": "summary" },
        React.createElement(CreditCardSummary_1.CreditCardSummary, { card: value, onSetCard: onChange, disclaimer: disclaimer })));
};
exports.CreditCardInput = CreditCardInput;
//# sourceMappingURL=index.js.map